import { put, call, all, takeEvery, takeLatest } from "redux-saga/effects";
import { calculateAchPostDate, checkPayoff } from "../utils/requests";

export function* calculateAchPostDateFromEndpoint({ paymentDetails }) {
  let checkPayoffObject = {
    Amount: parseFloat(paymentDetails.Amount || paymentDetails.amount),
    AchOrDebit: "ach",
    AchRoutingNumber: paymentDetails.RoutingNumber,
    AchAccountNumber: paymentDetails.AccountNumber,
    AchIsChecking: paymentDetails.isChecking,
    isPrincipalOnly: paymentDetails.isPrincipalOnlyAch,
  };

  try {
    yield put({
      type: "CLEAR_PAYOFF_CHECK",
    });
    yield put({
      type: "HIDE_NOTIFICATION",
    });
    yield put({
      type: "SHOW_MODAL",
      modalType: "loading",
      message: "Loading..."
    });
    const payoffCheck = yield call(checkPayoff, checkPayoffObject);
    yield put({
      type: "SET_PAYOFF_CHECK",
      payload: payoffCheck,
    });

    if (payoffCheck.Message != "") {
      yield put({
        type: "SHOW_NOTIFICATION",
        notificationType: "error",
        message: payoffCheck.Message,
      });

      if (paymentDetails.isPrincipalOnlyAch && payoffCheck.PaymentTypeChangedToPayoff) {
        yield put({
          type: "SET_PRINCIPAL_PAYOFF_SWITCH",
          switch: true,
        });
        yield put({
          type: "HIDE_MODAL",
          modalType: "loading",
        });
        return;
      }

      // End saga if payment is not allowed for this submission
      yield put({
        type: "HIDE_MODAL",
        modalType: "loading",
      });
      return;
    }
    const data = yield call(calculateAchPostDate, paymentDetails);
    paymentDetails.PostDate = data;
    yield put({
      type: "GET_POST_DATE",
      payload: paymentDetails,
    });
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading",
    });
  } catch (error) {
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading",
    });
    // Send UI to error page since we didn't get a post date
    yield put({
      type: "ERROR_PAGE",
    });
  }
}

// Watch for token request and execute action to set token
export function* watchTransferFormRequest() {
  yield takeEvery("TRANSFER_FORM", calculateAchPostDateFromEndpoint);
}



// WEBPACK FOOTER //
// ./src/sagas/transferForm.sagas.js